export const RECENT_LOCATIONS_KEY = "eventRecentLocations";
export const GOOGLE_PLACES_SCRIPT_ID = "google-places-api";
export const MAX_LOCATION_SUGGESTIONS = 6;
export const GOOGLE_PLACES_DEBOUNCE_MS = 250;
export const GOOGLE_PLACES_SCRIPT_TIMEOUT_MS = 10000;
